import React                from 'react'
import {
  Link,
  useHistory
}                           from 'react-router-dom'
import { 
  useSelector,
  useDispatch
}                           from 'react-redux'

const Sidebar = () => {
  let history = useHistory();

  const onCloseHandle = () => {
    // dispatch(logout({}))
    history.push('/admin')
  }

  return (
    <div className="sidebar-container">
      <div className="sidbar-wrapper">
        <div className="panel-header">
          <div className="panel-logo"></div>
        </div>
        <div className="nav-item-wrapper">
          {/* <div className="nav-item">
            <Link to="/panel/main">
              <i className="fas fa-object-ungroup kolor"></i>
              <span className="link-text">Anasayfa</span>
            </Link>
          </div> */}
          {/* <div className="nav-item">
            <Link to="/panel/landing-page">
              <i className="fas fa-book kolor"></i>
              <span className="link-text">Landing Page</span>
            </Link>
          </div> */}

          <div className="nav-item">
            <Link to="/panel/services">
              <i className="fas fa-feather kolor"></i>
              <span className="link-text">Hizmetler</span>
            </Link>
          </div>
          <div className="nav-item">
            <Link to="/panel/sectors">
              <i className="fas fa-feather kolor"></i>
              <span className="link-text">Sektörler</span>
            </Link>
          </div>
          {/* <div className="nav-item">
            <Link to="/panel/consultancy">
              <i className="fas fa-feather kolor"></i>
              <span className="link-text">Danışmanlık</span>
            </Link>
          </div> */}
          <div className="nav-item">
            <Link to="/panel/blog">
              <i className="fas fa-feather kolor"></i>
              <span className="link-text">Blog</span>
            </Link>
          </div>
          <div className="nav-item">
            <Link to="/panel/contact">
              <i className="fas fa-feather kolor"></i>
              <span className="link-text">Hakkımızda</span>
            </Link>
          </div>
        </div>
        <div className="nav-close">
          <div className="nav-close-content">
            <button className="nav-close-content-button" onClick={onCloseHandle}>
              Cikis Yap
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
